module.exports = __webpack_public_path__ + "img/right.3fe288db.svg";